<template>
<div class="vpn-download">
  <HeadNav />
  <main class="vpn-download__main">
    <DownloadHeroSection />
    <div class="vpn-download__body">
      <ApkSafetySection />
      <SetupSection />
      <DownloadNoticeSection />
    </div>
  </main>
</div>
</template>

<script>
import '@/css/vpn-theme.scss'
import HeadNav from '@/components/HeadNav.vue'
import DownloadHeroSection from '@/components/vpn/DownloadHeroSection.vue'
import ApkSafetySection from '@/components/vpn/ApkSafetySection.vue'
import SetupSection from '@/components/vpn/SetupSection.vue'
import DownloadNoticeSection from '@/components/vpn/DownloadNoticeSection.vue'

export default {
  name: 'GetFreeVpn',
  components: {
    HeadNav,
    DownloadHeroSection,
    ApkSafetySection,
    SetupSection,
    DownloadNoticeSection,
  },
  mounted() {
    if (typeof document !== 'undefined') {
      document.body.classList.add('vpn-site')
    }
  },
  beforeDestroy() {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('vpn-site')
    }
  },
}
</script>

<style lang="scss" scoped>
.vpn-download__body {
  width: var(--vpn-content-width);
  max-width: 100%;
  margin: 20px auto 48px;
  display: grid;
  gap: 20px;
}
</style>
